import script from "./CoverageModeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageModeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./CoverageModeSelector.vue?vue&type=style&index=0&id=0c301c26&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c301c26"]])

export default __exports__